// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../szc.cycz.cc/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.company-info_form[data-v-6934384b] {\n  padding: 10px 60px 0px 20px\n}\n.dialog-footer[data-v-6934384b] {\n  position: absolute;\n  right: 20px;\n  bottom: 20px;\n}\n\n", ""]);
// Exports
module.exports = exports;
